import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as SessionActions from '../../stores/actions/session';
import WaitingIndicator from '../general-components/waiting-indicator';
import { useMediaDevicesContext } from '../../contexts/media/check-media';

export default function ConfirmAppEntry() {
	const dispatch = useDispatch();
	const { checkMediaDevices } = useMediaDevicesContext();

	useEffect(() => {
		checkMediaDevices()
			.then(() => dispatch(SessionActions.setOnboardingComplete(true)));
	}, []);

	return (
		<div className='position-absolute align-items-center width-full height-full'>
			<WaitingIndicator />
		</div>
	);
}
